<template>
    <div class="fhv-centent" v-loading="loading" >
        <h4 class="title-topic" >Access Control — IP Address Configuration</h4>
        <el-alert
            v-if="$isTRUE"
            title="Note:Remote access to this GUI available only if password changed and HTTP-wan enabled."
            :closable="false"
            type="error">
        </el-alert>
        <div class="change">
            <label for="">ACL Enable :</label>
             <el-switch v-model="flag"  @change="swiChange" :disabled="$G_DEVICE_CFG.isReadOnly"></el-switch>
        </div>

        <el-table :data="tableData" stripe style="width: 100%" border class="fhv-table" v-if="flag">
            <el-table-column prop="type" label="Service Type" ></el-table-column>
            <el-table-column prop="direction" label="Access Direction"></el-table-column>
            <el-table-column prop="protocol" label="Protocol"></el-table-column>
            <el-table-column prop="range" label="IP Range" width="200"></el-table-column>
            <el-table-column prop="status" label="Status"></el-table-column>
            <el-table-column prop="address" label="Method">
                  <template slot-scope="scope">
                    <el-button
                        @click.native.prevent="deleteRow(scope.$index, tableData)"
                        :disabled="$G_DEVICE_CFG.isReadOnly"
                        type="text"
                        size="small">
                        Delete
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
         <div class="btn-contain" v-if="flag">
            <el-button type="primary" @click="dialogFormVisible = true" :disabled="$G_DEVICE_CFG.isReadOnly">Add</el-button>
        </div>


        <el-dialog title="Access Control -- IP Address Configuration" width="40%" :visible.sync="dialogFormVisible" :lock-scroll="false">
            <el-form :model="form" size="mini" :rules="rules" ref="forms">
                <el-form-item label="Protocol:" :label-width="formLabelWidth">
                    <el-select v-model="form.protocol" placeholder="Please select">
                         <el-option v-for="(item,index) in protocolLists" :key="index" :label="item.label" :value="item.value"></el-option>
                     </el-select>
                </el-form-item>
                <el-form-item label="Access Control:" :label-width="formLabelWidth">
                    <el-select v-model="form.control" placeholder="Please select" >
                         <el-option label="WAN" value="2"></el-option>
                         <el-option label="LAN" value="1"></el-option>
                     </el-select>
                </el-form-item>
                <el-form-item label="IP Protocol Type:" :label-width="formLabelWidth">
                    <el-select v-model="form.type" placeholder="Please select">
                         <el-option label="IPv4" value="1"></el-option>
                         <el-option label="IPv6" value="2"></el-option>
                     </el-select>
                </el-form-item>

                <el-form-item label="Enable:"  :label-width="formLabelWidth">
                  <el-switch v-model="form.flag"></el-switch>
                </el-form-item>

                <el-form-item label="Source IP:" :label-width="formLabelWidth">
                     <el-col :span="11">
                    <el-form-item prop="ip1">
                      <el-input v-model="form.ip1" auto-complete="off"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col class="line" :span="2" style="text-align:center;">-</el-col>
                  <el-col :span="11">
                    <el-form-item prop="ip2">
                     <el-input v-model="form.ip2" auto-complete="off"></el-input>
                    </el-form-item>
                  </el-col>
                </el-form-item>
                
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">cancel</el-button>
                <el-button type="primary" @click="addData">confirm</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      flag: true,
      dialogFormVisible: false,
      form: {
        name: "",
        protocol: "1",
        control: "1",
        type: "1",
        flag: false,
        ip1: "",
        ip2: ""
      },
      formLabelWidth: "180px",
      protocolLists: [
        { label: "HTTP", value: "1" },
        { label: "HTTPS", value: "9" },
        { label: "TELNET", value: "2" },
        { label: "SSH", value: "3" },
        { label: "ICMP", value: "4" },
        { label: "FTP", value: "5" },
        { label: "TFTP", value: "6" },
        { label: "SAMBA", value: "7" },
        { label: "SNMP", value: "8" }
      ],
      tableData: [],
      rules: {
        ip1: [
          {
            validator: (rule, value, callback) => {
              if(this.form.ip1 === '' && this.form.ip2 === '')
              {
                  callback();
              }
              else if (this.form.type == 1) {
                if (!validator.isIP(value, 4)) {
                   callback(new Error("Source start IP address error!"));
                }else{
                   callback();
                }
              } else {
                if (!validator.isIP(value, 6)) {
                   callback(new Error("Source end IP address error!"));
                }else{
                   callback();
                }
              }
            },
            trigger: "blur"
          }
        ],
        ip2: [
          {
            validator: (rule, value, callback) => {
              if(this.form.ip1 === '' && this.form.ip2 === '')
              {
                  callback();
              }
              else if (this.form.type == 1) {
                if (!validator.isIP(value, 4)) {
                   callback(new Error("Source start IP address error!"));
                }else{
                   callback();
                }
              } else {
                if (!validator.isIP(value, 6)) {
                   callback(new Error("Source end IP address error!"));
                }else{
                   callback();
                }
              }
            },
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    swiChange() {
      if (this.flag == true) {
        var ACLSwitch = 1;
      } else {
        var ACLSwitch = 0;
      }
      var postData = {
        CmdType: "SET_ACL_ENABLE",
        ACLSwitch: ACLSwitch
      };
      this.loading = true;
      axios.post("/boafrm/fromACL", postData).then(res => {
        this.loading = false;
        var data = res.data;
        if (data == "undefined" || data == "") {
          this.$message.error("Data acquisition error!");
          return;
        }

        if (data.ret == "0") {
          this.$message.success("Configuration is successful！");
        } else {
          this.$message.error(data.errorMsg);
        }
      });
    },
    deleteRow(index, rows) {
      this.acl().delData(index + 1);
    },
    addData() {
      this.acl().addData();
    },

    acl() {
      var _this = this;
      let ACL = {
        data: {
          ACLEnable: 0,
          ACLLists: []
        },
        getData: function() {
          let postData = {
            CmdType: "GET_ACL"
          };
          _this.loading = true;
          axios.post("/boafrm/fromACL", postData).then(res => {
            _this.loading = false;
            var data = res.data;
            if (data == "undefined" || data == "") {
              _this.$message.error("Data acquisition error!");
              return;
            }

            if (data.ACLEnable == "1") {
              _this.flag = true;
            } else {
              _this.flag = false;
            }
            if (data.ACLLists && data.ACLLists.length > 0)
              ACL.data.ACLLists = data.ACLLists;
            ACL.setTableData();
          });
        },
        addData() {
         
          if (_this.form.flag == true) {
            var enable = 1;
          } else {
            var enable = 0;
          }
          var postData = {
            CmdType: "SET_ACL_ADD",
            ACLEnable: enable,
            ACLAccesscontrol: _this.form.control,
            ACLProtoType: _this.form.protocol,
            ACLIpVer: _this.form.type
          };

          if(_this.form.type == 1)
          {
              postData.ACLSipAddrStart = _this.form.ip1
              postData.ACLSipAddrEnd = _this.form.ip2
          }
          else
          {
              postData.ACLSipAddr6Start = _this.form.ip1
              postData.ACLSipAddr6End = _this.form.ip2
          }
          _this.$refs["forms"].validate(valid => {
            if (valid) {
              _this.loading = true;
               _this.dialogFormVisible = false;
              axios.post("/boafrm/fromACL", postData).then(res => {
                _this.loading = false;
               
                let data = res.data;
                if (data == "undefined" || data == "") {
                  _this.$message.error("Data acquisition error!");
                  return;
                }
                if (data.ret == "0") {
                  _this.$message.success("Add success!");
                  _this.tableData = [];
                  ACL.getData();
                } else {
                  _this.$message.error(`Add failed! Error message:${data.errorMsg}`);
                }
              });
            }
          });
        },
        delData(index) {
          let postData = {
            CmdType: "SET_ACL_DEL",
            ACLNum: index
          };
          _this.loading = true;
          axios.post("/boafrm/fromACL", postData).then(res => {
            _this.loading = false;
            let data = res.data;
            if (data == "undefined" || data == "") {
              _this.$message.error("Data acquisition error!");
              return;
            }

            if (data.ret == "0") {
              _this.$message.success("Delete succeeded!");
              _this.tableData = [];
              ACL.getData();
            } else {
              _this.$message.error(`Delete failed! Error message:${data.errorMsg}`);
            }
          });
        },
        setTableData() {
          var protoTypeVal = {
            "1": "HTTP",
            "9": "HTTPS",
            "2": "TELNET",
            "3": "SSH",
            "4": "ICMP",
            "5": "FTP",
            "6": "TFTP",
            "7": "SAMBA",
            "8": "SNMP"
          };
          var accesscontrolVal = {
            "1": "LAN",
            "2": "WAN"
          };
          var lists = ACL.data.ACLLists;
          for (var index = 0; index < lists.length; index++) {


            var type = protoTypeVal[lists[index].protoType];

            var direction = accesscontrolVal[lists[index].accesscontrol];
            if (lists[index].ipVer == "1") {
              // ipv4
              var protocol = "IPv4";
              if (
                lists[index].sipAddrStart == "0.0.0.0" &&
                lists[index].sipAddrEnd == "0.0.0.0"
              ) {
                var range = "Any";
              } else {
                var range =
                  lists[index].sipAddrStart + "-" + lists[index].sipAddrEnd;
              }
            } else if (lists[index].ipVer == "2") {
              // ipv6
              var protocol = "IPv6";
              if (
                lists[index].sipAddr6Start == "" &&
                lists[index].sipAddr6End == ""
              ) {
                var range = "Any";
              } else {
                var range =
                  lists[index].sipAddr6Start + "-" + lists[index].sipAddr6End;
              }
            } else {
              var protocol = "-";
              var range = "-";
            }
            var status = lists[index].enable ? "Enable" : "Disable";

            _this.tableData.push({
              type: type,
              direction: direction,
              protocol: protocol,
              range: range,
              status: status
            });
          }
        }
      };
      return ACL;
    }
  },
  created() {
    this.acl().getData();
  }
};
</script>
<style lang="scss" scoped>
.fhv-centent {
  h4 {
    margin-bottom: 15px;
  }
  p {
    margin-bottom: 15px;
  }
  .change {
    margin: 20px 0;
  }
  .btn-contain {
    width: 100%;
    margin-top: 10px;
    padding: 0;
    text-align: center;
  }
}
</style>



